module.exports = __webpack_public_path__ + "img/upwork.2a9b6c96.png";